import { useState, useEffect, useRef } from "react";
import {
  TableWrapper,
  HeaderComponent,
  BodyComponent,
  RowComponent,
  Widgets,
  UpSortArrow,
  DownSortArrow
} from "./styles";
import { Column } from "../../grids/Grids";
import Filter from "../filter";
import DisplayMessage from "../displayMessage";
import Checkbox from "../checkbox";
import { withTranslation } from "react-i18next";

function TableHeader({
  background, color, border, column, grid, showWidgets, filterList, selectAll,
  fontWeight, fontSize, isSortEnabled, sortColumns, selectedSortColumn, sortType,
  showSelect, handleSelectAll, selectAllChecked, justifyContent,
  options: optionsProp, handleCollapseExpand, isLoading, sortCallback: sortCallbackProp, t
}) {
  const [options, setOptions] = useState(optionsProp || []);

  useEffect(() => {
    setOptions(optionsProp || []);
  }, [optionsProp]);

  const handleSort = (item) => {
    const sortTypeVal = selectedSortColumn === item && sortType === "asc" ? "desc" : "asc";
    if (sortCallbackProp) sortCallbackProp(item, sortTypeVal);
  };

  const { xs, sm, md, lg } = grid;
  return (
    <HeaderComponent
      background={background}
      color={color}
      border={border}
      verticalalign="center"
      fontWeight={fontWeight}
      fontSize={fontSize}
      justifyContent={justifyContent}
      data-testid="header-component"
    >
      {column.map((item, i) =>
        isSortEnabled ? (
          <Column
            key={i}
            xs={xs[i]}
            sm={sm[i]}
            md={md[i]}
            lg={lg[i]}
            color={selectedSortColumn === item ? "#5582BA" : "#999999"}
            onClick={() => handleSort(item)}
          >
            {window.location.href?.includes("/team") ? item : <>{t(item)}</>}
            {sortColumns.indexOf(item) >= 0 ? (
              selectedSortColumn === item && sortType === "desc" ? (
                <DownSortArrow />
              ) : (
                <UpSortArrow />
              )
            ) : (
              ""
            )}
          </Column>
        ) : (
          <Column key={i} xs={xs[i]} sm={sm[i]} md={md[i]} lg={lg[i]}>
            {window.location.href?.includes("/team") ? item : <>{t(item)}</>}
          </Column>
        )
      )}
      {showSelect && (
        <Column xs="1" sm="1" md="1" lg="1">
          <Checkbox name="select-all" onChange={handleSelectAll} checked={selectAllChecked} />
        </Column>
      )}
      {showWidgets ? (
        <Widgets xs="1" sm="1" md="1" lg="1">
          <Filter
            options={options}
            filterList={filterList}
            selectAll={selectAll}
            handleCollapseExpand={handleCollapseExpand}
            isloading={isLoading}
          />
        </Widgets>
      ) : (
        ""
      )}
    </HeaderComponent>
  );
}

export function TableBody({
  height, onScroll, showloader, children, loaderAlign, name,
  uiconstants, background, content, isFromWorkOrder, customStyles
}) {
  const tableBodyRef = useRef(null);

  const getBoundingClientRect = tableBodyRef.current
    ? tableBodyRef.current.getBoundingClientRect()
    : 0;
  const scroll = tableBodyRef.current
    ? parseInt(getBoundingClientRect.height + getBoundingClientRect.top)
    : 0;
  const message = !isFromWorkOrder ? (content ? content : "No Recent " + name + " Available!") : "";
  return (
    <BodyComponent
      height={height}
      width="auto"
      onScroll={() => onScroll(tableBodyRef.current)}
      ref={tableBodyRef}
      loading={showloader}
      loaderAlign={loaderAlign}
      scroll={scroll}
      background={background}
      style={customStyles}
      data-testid="table-body"
    >
      {showloader || (children && children.length) ? (
        children
      ) : (
        <><DisplayMessage message={message} uiconstants={uiconstants} /></>
      )}
    </BodyComponent>
  );
}

export function TableRow({
  background, color, fontSize, border, padding, grid, properties, handleRowClick,
  showWidgets, markAsRead, showSelect, handleSelect, isChecked, checkboxValue, position, customStyles
}) {
  const { xs, sm, md, lg } = grid;
  return (
    <RowComponent
      style={customStyles}
      onClick={() => handleRowClick()}
      verticalalign="center"
      markAsRead={markAsRead}
      color={color}
      fontSize={fontSize}
      padding={padding}
      border={border}
      background={background}
      position={position}
      data-testid="row-component"
    >
      {properties.map((property, j) => (
        <Column key={j} xs={xs[j]} sm={sm[j]} md={md[j]} lg={lg[j]}>
          {property}
        </Column>
      ))}
      {showSelect && (
        <Column xs="1" sm="1" md="1" lg="1">
          <Checkbox name="select-row" onChange={handleSelect} checked={isChecked} value={checkboxValue} />
        </Column>
      )}
      {showWidgets ? <Column xs="1" sm="1" md="1" lg="1" /> : ""}
    </RowComponent>
  );
}

export default function Table({ border, paddingTop, paddingLeft, background, children }) {
  return (
    <TableWrapper
      border={border}
      paddingTop={paddingTop}
      paddingLeft={paddingLeft}
      background={background}
      data-testid="table-wrapper"
    >
      {children}
    </TableWrapper>
  );
}

export const TranslatedTableHeader = withTranslation()(TableHeader);

